module.exports = __webpack_public_path__ + "img/avatar-lg.f19186a4.svg";